import produce from 'immer'

import {
  FETCH_CITIES_REQUESTED,
  FETCH_CITIES_SUCCEED,
  FETCH_CITIES_FAIL,
} from './actionTypes'


const initialState = {
  isCitiesLoading:true,
  cities:[],
  error: null
}

const CityErrors = {
  fetchCitiesFailed: 'Не удалось обновить список городов.'
}

const citiesReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_CITIES_REQUESTED:
      draft.error = null
      draft.isCitiesLoading = true
      return draft

    case FETCH_CITIES_SUCCEED:
      draft.cities = action.payload.cities
      draft.isCitiesLoading = false
      return draft

    case FETCH_CITIES_FAIL:
      draft.error = action.error
      draft.errorText = CityErrors.fetchCitiesFailed
      return draft

    default:
      return draft
  }
})
export default citiesReducer



// WEBPACK FOOTER //
// ./src/store/cities/reducer.js